import { render, staticRenderFns } from "./BFormTextareaLimited.vue?vue&type=template&id=75075162&scoped=true&"
import script from "./BFormTextareaLimited.vue?vue&type=script&lang=js&"
export * from "./BFormTextareaLimited.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75075162",
  null
  
)

export default component.exports